import { module } from 'angular';
import templateBuilderNameDisplay from './builder/display.html';
import templateBuilderNameAPI from './builder/api.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/name/display.html', templateBuilderNameDisplay);
	$templateCache.put('kform/components/name/api.html', templateBuilderNameAPI);
});
